import { isFunction } from '@/scripts/utils';

/*  */
const { VUE_APP_WEBSOCKET_URL } = process.env;

const wsConnection = new (class {
  constructor() {
    this.connections = {};
    this.callbacks = {};

    /* TODO: test mode */
    /* setInterval(() => {
      window.console.log('this', { ...this });
    }, 1000); */
  }

  connect(endpoint, token = this.token) {
    if (!window.WebSocket)
      return console.warn('window.WebSocket', window.WebSocket);

    const connection = new WebSocket(
      `${VUE_APP_WEBSOCKET_URL}/${endpoint}?xAccessToken=${token}`
    );

    connection.endpoint = endpoint;
    connection.maintainId = this.maintainConnection(connection);
    this.setListeners(connection);

    this.connections[endpoint] = connection;
  }

  setListeners(connection) {
    connection.onmessage = this.parseMessage.bind(this);
    connection.onopen = this.onOpen.bind(this);
    /* connection.onopen = e => console.log('onopen', e); */
    connection.onclose = e => this.reconnectOnClose.bind(this)(e, connection);
    connection.onerror = e => {
      console.warn('ws onerror', e);

      this.crashState = true;

      if (isFunction(this.onCrushCallback)) this.onCrushCallback('error');
    };
  }

  onOpen() {}

  setOnCrushCallback(callback) {
    this.onCrushCallback = callback;

    if (this.crashState && callback) callback(this.crashState);
  }

  reconnectOnClose(e = {}, connection) {
    const { code } = e;
    const { endpoint } = connection;

    if (code === 1000) return;

    this.crashState = true;

    this.connect(endpoint);
  }

  setCallback(name, func) {
    if (!name || !func) return;

    this.callbacks[name] = func;
  }

  removeCallback(name) {
    if (!name || !this.callbacks[name]) return;

    this.callbacks[name] = null;
  }

  parseMessage(e) {
    const data = JSON.parse(e.data);
    /* connectionID, timestamp */
    const { event } = data;
    const callbackCandidate = this.callbacks[event];

    if (isFunction(callbackCandidate)) callbackCandidate(data);
  }

  /* reconnect() {
    const {} = this;
    const result = null;

    return result;
  } */

  close(connection) {
    const { /* endpoint, */ maintainId } = connection;
    clearInterval(maintainId);
    connection.close(1000);
    /* TODO: */
    /* this.connections[endpoint] = null; */
  }

  maintainConnection(connection) {
    const interval = 30 * 1000;

    const id = setInterval(() => {
      connection.send('ping');
    }, interval);

    return id;
  }

  closeAll() {
    const { connections } = this;

    Object.values(connections).forEach(this.close);
  }

  reset() {
    this.closeAll();
    this.setToken(null);

    this.connections = {};
    this.callbacks = {};
  }

  reconnect() {
    Object.values(this.connections).forEach(connection => {
      this.connect(connection.endpoint);
    });
  }

  setToken(token) {
    this.token = token;
  }
})();

/*  */
export { wsConnection };
